import * as React from 'react';
import {Dispatch} from 'redux';
import {connect} from 'react-redux';
import {withRouter, RouteComponentProps} from 'react-router-dom';

import {globalDispatchToPropsObject} from '../../store';
import {BusyIndicator, ErrorToast} from '../util';
import Navbar from './Navbar';
import EditorHelp from '../config-editor/EditorHelp';

interface StateProps {
	errors: any[];
	loading: boolean;
}

interface DispatchProps {
	dismissError(error: any): void;
}

interface State {
	showHelpModal: boolean;
}

type Props = StateProps & DispatchProps & RouteComponentProps<{}>;

function mapStateToProps({global}: StudioState): StateProps {
	return {
		loading: global.loading.length > 0,
		errors: global.errors,
	};
}

function mapDispatchToProps(dispatch: Dispatch<StudioState>): DispatchProps {
	const {dismissError} = globalDispatchToPropsObject;
	return {
		dismissError: error => dispatch(dismissError(error)),
	};
}

class AppContainer extends React.Component<Props, State> {

	public state: State = {
		showHelpModal: false,
	};

	constructor(props: Props, context: any) {
		super(props, context);
		this.handleClickHelp = this.handleClickHelp.bind(this);
		this.handleCloseHelpModal = this.handleCloseHelpModal.bind(this);
	}

	public render() {
		return <div className='main-container'>
			<Navbar
				onClickHelp={this.handleClickHelp}
				location={this.props.location.pathname}
			/>
			<ErrorToast errors={this.props.errors} onDismiss={this.props.dismissError} />
			{this.renderLoading()}
			{this.renderHelpModal()}
			{this.props.children}
		</div>;
	}

	private renderHelpModal() {
		return <EditorHelp
			showAsModal
			onClose={this.handleCloseHelpModal}
			isOpen={this.state.showHelpModal}
		/>;
	}

	private renderLoading() {
		if (this.props.loading) {
			return <BusyIndicator fullscreen />;
		} else {
			return null;
		}
	}

	private handleClickHelp() {
		this.setState({showHelpModal: true});
	}

	private handleCloseHelpModal() {
		this.setState({showHelpModal: false});
	}
}

export default withRouter(connect<StateProps, DispatchProps, {}>
	(mapStateToProps, mapDispatchToProps)(AppContainer));



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./ts/components/config-studio-index/AppContainer.tsx